export default "__VITE_PUBLIC_ASSET__c60131ac__"